import { useState, useEffect } from "react"
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

export const useSignalR = ({ url = "/hub/notification", funcionRespuesta }) => {
  const [conexion, setConexion] = useState(null);

  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: () => localStorage.getItem("token")

      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    setConexion(connection);

    return () => {
      connection.stop();
    };
  }, [url]);

  useEffect(() => {
    if (!conexion) return;

    const handler = (data) => {
      console.log("📩 SignalR recibió:", data);
      funcionRespuesta(data);
    };

    conexion.on("ReceiveNotification", handler);

    conexion.start()
      .then(() => console.log("🟢 SignalR conectado"))
      .catch(err => console.error("SignalR error:", err));

    return () => {
      conexion.off("ReceiveNotification", handler);
    };

  }, [conexion]);

  return { conexion };
};
